export default defineAppConfig({
  ui: {
    primary: 'al-primary',
    gray: 'stone',
    notifications: {
      position: 'top-0 bottom-auto left-1/2 -translate-x-1/2',
    },
  },
})
